<template>
  <shimmer-personalized-offer v-if="isLoading"/>
  <div
    class="col-sm-12 pers-offers-wrap pl0 carousel-pr-12"
    :class="{ pr0: welcomeOffers.length > 1 }"
    v-if="welcomeOffers.length > 0"
  >
    <h3 class="fs-18 bold lh20 mb8 pl12" :vwoObserver="vwoExperiments">
      {{ welcomeOfferModuleTitle }}
    </h3>
    <Carousel
      :items-to-show="itemsToShow"
      :pauseAutoplayOnHover="true"
      :transition="500"
      :touchDrag="false"
      :mouseDrag="false"
    >
      <Slide v-for="(item, index) in dataToShow" :key="index">
        <div
          class="pers-offer flex-row"
          v-if="item.type != 'MILESTONE' && !item.noshowInPersonalize"
          :style="{ width: widgetWidthHeight.width + 'px' }"
          @click="
            !isOpenOfferAppliedModal || selectedOfferIndex !== index
              ? triggerUnAppliedMilestoneTncModal($event, index)
              : setTncModalTrue(index)
          "
        >
          <Observer
            :options="{ rootMargin: '0px' }"
            @intersect="offersVisible(index)"
          />
          <div>
            <div class="fs-14 lh-20 bold offer-title disp-col-inline">
              <i class="jfi-offer-tag mr8 jfi-offers-v2"></i>
              <span class="three-dot">{{ item.title || item.text }}</span>
            </div>
            <div class="fs-12 lh-18 offer-desc three-dot">
              {{ item.description }}
            </div>
          </div>
          <button
            v-if="selectedOfferIndex !== index"
            class="line-btn sm"
            @click.stop="
              !isOpenOfferAppliedModal || selectedOfferIndex !== index
                ? triggerUnAppliedMilestoneTncModal($event, index)
                : setTncModalTrue(index)
            "
          >
            View
          </button>
          <div
            v-if="selectedOfferIndex == index"
            class="flex-column already-applied pl16"
          >
            <i class="jfi-checkmark-circled fs-13"></i>
            <div>Applied!</div>
          </div>
        </div>
        <div
          class="milestone-offer flex-row"
          v-if="item.type == 'MILESTONE' && !item.noshowInPersonalize"
          :style="{ width: widgetWidthHeight.width + 'px' }"
          @click="
            !isOpenOfferAppliedModal || selectedOfferIndex !== index
              ? triggerUnAppliedMilestoneTncModal($event, index)
              : setTncModalTrue(index)
          "
        >
          <Observer
            :options="{ rootMargin: '-50px' }"
            @intersect="offersVisible(index)"
          />
          <div>
            <ul class="fs-14 bold disp-col-inline ms-timeline">
              <li
                class=""
                v-for="(mileStoneItem, i) in item.milestonesCouponDTOList"
                :key="i"
              >
                <div class="bold order-no">
                  {{ i + 1 }}{{ nth(i + 1) }} Order
                </div>
                <div class="fs-10 bold three-dot ms-title">
                  {{ mileStoneItem.title }}
                </div>
                <div class="border-arrow-img"></div>
              </li>
            </ul>
          </div>
          <button
            v-if="selectedOfferIndex !== index"
            class="line-btn sm"
          >
            View
          </button>
          <div
            v-if="selectedOfferIndex == index"
            class="flex-column already-applied pl16"
          >
            <i class="jfi-checkmark-circled fs-13"></i>
            <div>Applied!</div>
          </div>
        </div>
      </Slide>
    </Carousel>

    <!-- Milestone/tnc unapplied state popup shown on banner click -->
    <generic-modal
      v-if="showUnAppliedMilestoneTncModal"
      @close="closeUnAppliedMilestoneTncModal('dismiss')"
      :height="msModalDim.height"
      :width="msModalDim.width"
      :animationStyle="msModalDim.animationStyle"
      :genericModalSource="'milestoneOfferDetail'"
    >
      <template v-slot:header>
        <i
          @click="closeUnAppliedMilestoneTncModal('cross')"
          class="jfi-cross sticky-pop-cross"
        ></i>
      </template>
      <template v-slot:body>
        <div class="ms-offer-pop-content">
          <div class="logo-box mb10">
            <div class="logo-sm-img"></div>
          </div>
          <div class="fs-18 bold mb15">
            {{
              welcomeOffers[currentMileStoneIndex].type === "MILESTONE"
                ? "Milestone Offer"
                : welcomeOffers[currentMileStoneIndex]?.title
            }}
          </div>
          <ul class="fs-14 bold disp-col-inline ms-timeline">
            <li
              v-for="(mileStoneItem, i) in welcomeOffers[currentMileStoneIndex]
                ?.milestonesCouponDTOList"
              :key="i"
            >
              <div class="bold order-no color-grey">
                {{ i + 1 }}{{ nth(i + 1) }} Order
              </div>
              <div class="fs-12 bold color-green pl10">
                {{ mileStoneItem.title }}
              </div>
              <div class="border-arrow-img-grey"></div>
            </li>
          </ul>
          <div class="offer-state">
            <div class="coupan-dets color-slaty ib">
              Coupon code:
              <span class="bold italic">{{
                welcomeOffers[currentMileStoneIndex]?.promoCode
              }}</span>
            </div>
            <!-- tobe shown when coupan code is applied -->
            <div class="code-applied-dets disp-col-inline hide">
              <span>Code NONSTOP60 applied!</span>
              <span class="bold remove-code">Remove</span>
            </div>
          </div>
          <div class="ms-offer-details">
            <h3 class="bold">Offer Details:</h3>
            <ul class="disc-styled mt10 color-grey fs-11">
              <li
                class="lh16 mb5"
                v-for="(tncItem, i) in selectedOfferTnc"
                :key="i"
              >
                {{ tncItem }}
              </li>
            </ul>
          </div>
          <div class="btn-wrap">
            <button
              class="btn medium bold"
              @click="
                triggerOfferAppliedModal(
                  $event,
                  currentMileStoneIndex,
                )
              "
            >
              Apply Offer
            </button>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <div></div>
      </template>
    </generic-modal>

    <!-- Offer Appplied popup -->
    <generic-modal
      v-if="showOfferAppliedModal"
      @close="closeAppliedModal()"
      :height="'auto'"
      :width="msModalDim.width"
      :modalClass="msModalDim.modalClass"
    >
      <template v-slot:header>
        <p></p>
      </template>
      <template v-slot:body>
        <div class="lottie-confetti">
          <VueLottiePlayer
            @animControl="anim => lottieConfetti = anim"
            name="confettiAnim"
            :autoplay="false"
            width="100%"
            height="100%"
            :path="
              staticImgBaseUrl +
              '/images/animation/confetti.json'
            "
          />
        </div>
        <div class="lottie-offer-icon">
          <VueLottiePlayer
            @animControl = "anim => lottieOfferIcon = anim"
            name="offerIconAnim"
            :autoplay="false"
            width="100%"
            height="100%"
            :path="
              staticImgBaseUrl +
              '/images/animation/offer-icon-animation.json'
            "
          />
        </div>
        <div
          v-if="showConfettiMessage"
          class="offer-applied-popup tc flex-column"
        >
          <div class="fs-12 lh18 normal mb10">
            Coupon Code
            <span class="upercase bold">{{
              welcomeOffers[selectedOfferIndex]?.promoCode
            }}</span>
            applied!
          </div>
          <div
            class="fs-18 lh25 bold"
            v-if="welcomeOffers[selectedOfferIndex].couponDetail?.maxCap"
          >
            You will save ₹{{
              welcomeOffers[selectedOfferIndex].couponDetail?.maxCap
            }}!
          </div>
          <div
            class="fs-18 lh25 bold"
            v-else-if="welcomeOffers[selectedOfferIndex].description"
          >
            {{
              welcomeOffers[selectedOfferIndex].description
            }}
          </div>
        </div>

      </template>
      <template v-slot:footer>
        <div></div>
      </template>
    </generic-modal>

    <!-- offer not applied msg modal -->
    <!-- @@Display Error Msg of non applied Coupon -->

    <!-- <generic-modal
      v-if="showOfferNotApplied"
      :height="msModalDim.height"
      :width="msModalDim.width"
      :animationStyle="msModalDim.animationStyle"
    >
      <template v-slot:header>
        <div class="bold fs-18">
        </div>
      </template>
      <template v-slot:body>
        <div class="">
          <p class="fs-16 lh20 error-msg pTB24 mb20">
            {{ offerFailedMsg }}
          </p>
        </div>
      </template>
      <template v-slot:footer>
        <div></div>
      </template>
    </generic-modal> -->
  </div>
</template>

<script>
import { Carousel, Slide } from "vue3-carousel";
import GenericModal from "./GenericModal.vue";
import Utility from "../helpers/utility";
import setEvents from "../helpers/events";
import { VWO_NEXTGEN_HOMEPAGE_EXPERIMENT } from "../config/vwoKeys";
import LocalStorageFunc from "../helpers/localStorageFunc";
import userActivityTracking from "../helpers/UserActivityTracking";
import Observer from "../assets/Observer.vue";
import ShimmerPersonalizedOffer from "./ShimmerPersonalizedOffer.vue";
import { staticImgBaseUrl } from "../config/apiEndpoints";
import "vue3-carousel/dist/carousel.css";
import {
  keyMapsAction,
  keyMapsGetter,
  keyMapsMutation,
} from "../helpers/storeKeys";
import { defineAsyncComponent } from "vue";

export default {
  name: "PersonalizedOffers",
  props: ["moduleProps"],

  components: {
    VueLottiePlayer: defineAsyncComponent(() => import("vue-lottie-player")),
    Carousel,
    Slide,
    GenericModal,
    Observer,
    ShimmerPersonalizedOffer,
  },

  data() {
    return {
      moduleProperty: {},
      showUnAppliedMilestoneTncModal: false,
      showOfferAppliedModal: false,
      msModalDim: {
        width: "100vw",
        height: "calc(91vh - 56px)",
        animationStyle: "slide-up-stick-bottom",
        modalClass: "modal-bg-blackout hide-vertical-scrollbar",
      },
      currentMileStoneIndex: -1,
      widgetWidthHeight: {},
      isInit: true,
      itemsToShow: 1,
      showOfferNotApplied: false,
      autoApplyFlag: false,
      isImpressionProcessed: {},
      staticImgBaseUrl: staticImgBaseUrl,
      lottieConfetti: null,
      lottieOfferIcon: null,
      showConfettiMessage: false,
      dataToShow : [],
    };
  },
  mounted() {
    this.moduleProperty = (this.moduleProps &&
      JSON.parse(this.moduleProps)) || {
      title: "Hi ${NAME}, we have amazing offers for you!",
      type: "",
      cardType: "",
      aspectRatio: "",
      itemsInScreen: "",
    };
    this.itemsToShow = +this.moduleProperty?.itemsInScreen;
    this.widgetWidthHeight = Utility.getWidgetWidthHeight(
      this.moduleProperty?.itemsInScreen,
      this.moduleProperty?.aspectRatio
    );
  },
  methods: {
    offersVisible(index) {
      if (!this.isImpressionProcessed[index + 1]) {
        this.isImpressionProcessed[index + 1] = true;
        this.eventFunction(false, {}, index);
      }
    },
    autoApply() {
      let _ = Utility.tryJsonParse(_siteProps_.props.autoApplyOffer);
      if (_?.type == "WELCOME" && _?.code) {
        for (let i = 0; i < this.welcomeOffers.length; i++) {
          if (this.welcomeOffers[i].promoCode == _.code) {
            LocalStorageFunc.setSessionStorageKey("isAutoApplyInitiated", true);
            this.triggerOfferAppliedModal(null, i);
            break;
          }
        }
      }
    },
    eventFunction(isClicked = false, eObj = "", index) {
      let preEventObj = {};
      let eventType = isClicked ? "Click" : "nghOfferImpression";
      let userAction = isClicked ? "click" : "impression";
      if (this.welcomeOffers[index]?.type == "MILESTONE") {
        preEventObj = {
          offerType: "milestone",
          milestoneStage: Utility.getMilestoneStage(this.welcomeOffers[index]),
          ...eObj,
        };
      } else {
        preEventObj = {
          offerType:
            this.welcomeOffers[index]?.couponDetail?.templatePrefix ==
            "fixDiscount"
              ? "flat discount"
              : "percentage discount",
          offerStage:
            this.selectedOfferIndex === index ? "applied" : "not applied",
          subCategory: "banner",
          ...eObj,
        };
      }
      preEventObj["positionWithinSection"] = index + 1;
      preEventObj["category"] = this.welcomeOffers[index]?.title?.toLowerCase();

      const eventObj = Utility.amplitudeEventObj(
        userAction,
        "offer section",
        "6",
        preEventObj
      );
      setEvents("amplitude", eventType, eventObj);
    },
    nth(n) {
      return ["st", "nd", "rd"][((((n + 90) % 100) - 10) % 10) - 1] || "th";
    },
    triggerUnAppliedMilestoneTncModal(event, index) {
      userActivityTracking.promoOfferView(this.welcomeOffers[index], 0);
      this.currentMileStoneIndex = index;
      this.$store.dispatch(keyMapsAction.OFFER_TNC_API, {
        promoCode: this.welcomeOffers[index].promoCode,
      });
      document.body.classList.add("body-stop-scroll-mobile");
      this.showUnAppliedMilestoneTncModal = true;
      //Amplitude click event load
      const popupSource = event.target.innerText === "View" ? "view" : "banner";
      this.$store.commit(keyMapsMutation.UPDATE_OFFFER_POPUP_SOURCE, popupSource);
      this.eventFunction(
        true,
        {
          offerStage:
            this.selectedOfferIndex === index ? "applied" : "not applied",
          subCategory: popupSource,
        },
        index
      );
    },
    setTncModalTrue(index) {
      const { promoCode } = this.welcomeOffers[index];
      this.$store.commit(keyMapsMutation.UPDATE_SELECTED_OFFER_TNC, []);
      promoCode &&
        this.$store.dispatch(keyMapsAction.OFFER_TNC_API, {
          promoCode: promoCode,
        });
      this.$store.commit(keyMapsMutation.UPDATE_SHOW_TNC_MODAL, true);
      this.$store.commit(keyMapsMutation.UPDATE_OFFFER_POPUP_SOURCE, "banner");
      this.eventFunction(
        true,
        {
          offerStage:
            this.selectedOfferIndex === index ? "applied" : "not applied",
          subCategory: "banner",
        },
        index
      );
    },
    closeUnAppliedMilestoneTncModal(source) {
      document.body.classList.remove("body-stop-scroll-mobile");
      this.showUnAppliedMilestoneTncModal = false;
      if (source) {
        //Amplitude Click event load
        this.eventFunction(
          true,
          {
            offerStage: "not applied",
            actionType: source == "cross" ? "cross tap" : "default dismiss",
            subCategory: this.popupSource,
          },
          this.selectedOfferIndex
        );
      }
    },
    triggerOfferAppliedModal(event, index, source) {
      event?.stopPropagation();

      //Amplitude click event load
      this.eventFunction(
        true,
        {
          offerStage:
            this.selectedOfferIndex === index ? "applied" : "not applied",
          subCategory: this.popupSource,
          actionType: "apply offer",
        },
        index
      );

      this.closeUnAppliedMilestoneTncModal();
      this.$store.commit(keyMapsMutation.UPDATE_SELECTED_OFFER_INDEX, index);
      LocalStorageFunc.updateCouponCode(
        this.$store.state.Offers.welcomeOffers[index].promoCode
      );
      document.body.classList.add("body-stop-scroll-mobile");
      this.showOfferAppliedModal = true;
      setTimeout(() => {
          this.lottieConfetti?.play();
          this.lottieOfferIcon?.play();
          this.showConfettiMessage = true;
          setTimeout(this.closeAppliedModal, 3000);
        }, 200);
      userActivityTracking.promoOfferApplied(
        0,
        this.$store.state.Offers.welcomeOffers[index].promoCode
      );
      this.$store.commit(keyMapsMutation.UPDATE_OFFER_APPLY_MODAL_KEY, true);
      let addZindex = document.getElementById("offerApply");
      addZindex && addZindex.classList.add("z-index-offer-applied");

      if (this.offerFailedMsg) {
        console.log("----", this.offerFailedMsg);
        this.showOfferNotApplied = true;
        setTimeout(() => {
          this.showOfferNotApplied = false;
        }, 4000);
      }
    },
    closeAppliedModal(event) {
      document.body.classList.remove("body-stop-scroll-mobile");
      this.showConfettiMessage = false;
      this.showOfferAppliedModal = false;
    },
  },
  computed: {
    isLoading() {
      return this.$store.state.Offers.isLoading;
    },
    welcomeOffers() {
      let data = this.$store.state.Offers.welcomeOffers || [];
      this.dataToShow = data.filter(item => {
        return item["noshowInPersonalize"] !== true;
      })
      return data
    },
    selectedOfferIndex() {
      return this.$store.state.Offers.selectedOfferIndex;
    },
    welcomeOfferModuleTitle() {
      return this.moduleProperty.title?.replace(
        "${NAME}",
        this.$store.getters[keyMapsGetter.GET_USER_DATA]?.firstName ||
          "Pizza Lover"
      );
    },
    selectedOfferTnc() {
      return this.$store.state.Offers.selectedOfferTnc;
    },
    offerFailedMsg() {
      return this.$store.state.Offers.offerFailedMsg;
    },
    isOpenOfferAppliedModal() {
      return this.$store.state.Offers.isOpenOfferAppliedModal;
    },
    isLocationSettled() {
      return this.$store.state.Location.isLocationSettled;
    },
    popupSource() {
      return this.$store.state.Offers.popupSource;
    },
    vwoExperiments() {
      let _ = this.$store.state.Config.vwoExperiments;
      let wO = this.$store.state.Offers.welcomeOffers;

      let appliedWelcomeOfferIndex = -1;
      if (LocalStorageFunc.getCouponCode()?.code !== undefined) {
        appliedWelcomeOfferIndex = wO.findIndex(
          (i) => i.promoCode == LocalStorageFunc.getCouponCode().code
        );
      }

      let autoApplyDefaultPersonalisedOfferRef =
        this.$store.state.Offers.autoApplyDefaultPersonalisedOfferRef;

      if (_?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] === "nextgen_variant_d") {
        if (
          autoApplyDefaultPersonalisedOfferRef &&
          appliedWelcomeOfferIndex == -1 &&
          !this.autoApplyFlag &&
          this.isLocationSettled &&
          LocalStorageFunc.getSessionStorageKey("isAutoApplyInitiated") != true
        ) {
          this.autoApplyFlag = true;
          setTimeout(() => {
            this.autoApply();
          }, 2000);
        }
      }
    },
  },
};
</script>
